import React from 'react';
import InputError from '../../shared/InputError/InputError';

interface RadioOption {
    id: string | number;
    label: string;
}

interface RadioButtonGroupProps {
    options: RadioOption[];
    value?: string | number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    name?: string;
    disabled?: boolean;
    error?: string;
}

/**
 * Componente RadioButtonGroup reutilizable
 * Maneja visualmente los errores de forma consistente con InputField
 */
const RadioButtonGroup: React.FC<RadioButtonGroupProps> = ({
    options,
    value,
    onChange,
    name = "radio",
    disabled = false,
    error,
}) => {
    return (
        <div className="space-y-1">
            <div className="flex flex-row gap-3">
                {options.map((option) => (
                    <label
                        key={option.id}
                        className={`flex items-center gap-3 cursor-pointer ${
                            disabled ? 'opacity-50 cursor-not-allowed' : ''
                        }`}
                    >
                        <input
                            type="radio"
                            name={name}
                            value={option.id}
                            checked={value === option.id}
                            onChange={onChange}
                            disabled={disabled}
                            className={`w-4 h-4 cursor-pointer ${
                                error ? 'border-red-500' : ''
                            }`}
                        />
                        <span className="text-neutral-700 dark:text-neutral-300">
                            {option.label}
                        </span>
                    </label>
                ))}
            </div>
            {error && <InputError>{error}</InputError>}
        </div>
    );
};

export default RadioButtonGroup;

